module.exports = __webpack_public_path__ + "static/img/club-evnet-04.527eaea.jpg";